import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { Columns } from '@shared/interfaces/table/column-config';

export const networkPlacementPartial: Columns<any> = {
  title: 'meterFrame.networkPlacement',
  key: 'networkPlacement',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    a0: 'meterFrame.networkPlacementsOptions.a0',
    ahighplus: 'meterFrame.networkPlacementsOptions.ahighplus',
    ahigh: 'meterFrame.networkPlacementsOptions.ahigh',
    alow: 'meterFrame.networkPlacementsOptions.alow',
    bhigh: 'meterFrame.networkPlacementsOptions.bhigh',
    blow: 'meterFrame.networkPlacementsOptions.blow',
    c: 'meterFrame.networkPlacementsOptions.c',
  }
}
